export default "__VITE_ASSET__BsO5elKV__"